import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo">
              <span>MD</span>
            </div>

            <div className="footer__brand-content">
              <h3>Makinaria Dima</h3>
              <p>
                Maquinaria industrial para empresas, talleres y operaciones que
                buscan productividad, precisión y soluciones confiables.
              </p>

              {/* 🔥 NUEVO BOTÓN FACEBOOK */}
              <a
                href="https://www.facebook.com/maquinaria.dima"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__facebook"
              >
                <i className="fab fa-facebook-f"></i>
                <span>Síguenos en Facebook</span>
              </a>
            </div>
          </div>

          <div className="footer__columns">
            <div className="footer__column">
              <h4>Navegación</h4>
              <ul>
                <li><a href="#inicio">Inicio</a></li>
                <li><a href="#nosotros">Nosotros</a></li>
                <li><a href="#categorias">Categorías</a></li>
                <li><a href="#catalogo">Catálogo</a></li>
                <li><a href="#contacto">Contacto</a></li>
              </ul>
            </div>

            <div className="footer__column">
              <h4>Contacto</h4>
              <ul>
                <li>
                  <a href="tel:5515898591">55 1589 8591</a>
                </li>
                <li>
                  <a
                    href={`https://wa.me/525515898591?text=${encodeURIComponent(
                      "Hola, vi su página y me interesa su maquinaria. ¿Me podrían dar más información?"
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    WhatsApp directo
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer__column">
              <h4>Ubicación</h4>
              <a href="https://maps.app.goo.gl/xHQ8YnBJu2tMt33Y7">
                C. Ingenieros Industriales 272, Col. Ex Hacienda de San
                Francisco Huatengo, 43774, Santiago Tulantepec, Hidalgo.
              </a>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© 2026 Makinaria Dima. Todos los derechos reservados.</p>
          <p>Maquinaria Industrial</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;